import { ListDriverOccupations } from '~/features/DriverOccupations'
import { PageContainer } from '~/shared/ui/PageContainer'
import { useRefreshPage } from './useRefreshPage'

export function ListDriverOccupationsPage() {
  const { refreshPage } = useRefreshPage()

  return (
    <PageContainer
      canBack
      backTitle='Типы занятости'
      title='Типы занятости'
      onRefreshPage={refreshPage}
    >
      <ListDriverOccupations />
    </PageContainer>
  )
}
